
<template>
  <div class="newPopup">
    <el-dialog
      :show-close="false"
      :visible.sync="dialogVisible"
      width="460px"
      :lock-scroll="false"
      :modal-append-to-body="false"
    >
      <div class="newPopup_diaog" @click="onclose"></div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  created() {},
  computed: {},
  methods: {
    onshow() {
      this.dialogVisible = true;
    },
    onclose() {
      this.dialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.newPopup {
  ::v-deep .el-dialog {
    background-color: rgba($color: #000000, $alpha: 0);
    box-shadow: none;
    margin-top: 0px !important;

    &__header {
      padding: 0;
    }

    &__body {
      padding: 0;
      background-color: rgba($color: #000000, $alpha: 0);
    }
  }

  &_diaog {
    // margin-top: calc((100vh - 565px) / 3);
    margin-top: 50px;
    background-image: url(~@/assets/image/weikaifang.webp);
    width: 460px;
    height: 288px;
    background-size: 460px 288px;
    background-repeat: no-repeat;
    position: relative;
  }
}
</style>
